const schema = () => ({
  type: 'object',
  required: [],
  properties: {
    category_id: {
      type: 'string',
      title: 'گروه',
    }
  },
});

export default schema;